/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
export const processorModuleDocumentType = "powerhouse/processor";
